import styled from 'styled-components';
import {
  fontFamilyPrimary,
  fontFamilySecondary,
  colorSecondary,
  colorBlack900,
  colorGrey400,
  mediaQueryMobileMin,
  mediaQueryLaptopMin,
} from 'styles';

import { ParagraphSmall } from 'components/Typography';

export const Wrapper = styled.div`
  padding: 28px 16px 16px 16px;
  margin: 16px 0;
  border-top: 2px solid #d30000;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
`;

export const Header = styled.div`
  text-align: center;
  margin-bottom: 16px;
`;

export const Title = styled.div`
  font-family: ${fontFamilySecondary};
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  margin-top: 16px;
`;

export const Content = styled.div`
  display: block;

  @media ${mediaQueryMobileMin} {
    display: flex;
    justify-content: center;
  }

  @media ${mediaQueryLaptopMin} {
    display: block;
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-right: 0;

  @media ${mediaQueryMobileMin} {
    width: 256px;
    margin-right: 16px;
  }

  @media ${mediaQueryLaptopMin} {
    width: 100%;
    margin-right: 0;
  }
`;

export const Label = styled.label`
  position: absolute;
  top: 16px;
  left: 12px;
  color: ${colorGrey400};
  letter-spacing: 0.03em;
  font-size: 12px;
  line-height: 16px;
  padding: 0 2px;
  background: #fff;
  transition: top 0.2s;
  cursor: text;

  ${({ isInputActive, inputValue }) =>
    isInputActive || inputValue
      ? `  
    top: -8px
    `
      : `top: 16px`};
`;

export const Input = styled.input`
  font-family: ${fontFamilyPrimary};
  font-size: 16px;
  line-height: 28px;
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 16px;
  color: ${colorBlack900};
  background: #fff;
  border: 1px solid #cacccb;
  box-sizing: border-box;
  border-radius: 2px;

  &:focus {
    outline: none;
  }
`;

export const SubscribeBtn = styled.button`
  width: 100%;
  padding: 12px 0;
  margin-bottom: 16px;
  font-family: ${fontFamilySecondary};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${colorSecondary};
  background: #fff;
  border: 1px solid ${colorSecondary};
  border-radius: 2px;

  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.9;
  }

  @media ${mediaQueryMobileMin} {
    width: 135px;
  }

  @media ${mediaQueryLaptopMin} {
    width: 100%;
  }
`;

export const Footer = styled.div`
  width: unset;
  margin: 0;
  text-align: unset;

  @media ${mediaQueryMobileMin} {
    width: 60%;
    margin: 0 auto;
    text-align: center;
  }

  @media ${mediaQueryLaptopMin} {
    width: unset;
    margin: 0;
    text-align: unset;
  }
`;

export const Description = styled(ParagraphSmall)`
  font-size: 12px;
  line-height: 16px;
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 50px 0;
`;

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 86px 0;
`;

export const SuccessTitle = styled.h3`
  font-family: ${fontFamilySecondary};
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  margin: 16px 0 8px 0;
`;

export const SuccessDesc = styled.p`
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
`;
